
const findEnumById = (type, id) => {
    return Object.values(type).find(item => item.id === id);
}


const MessageType = {
    INFO: "info",
    ERROR: "error",
    WARNING: "warning"
}


const YesNoType = {
    YES: { id: 1, label: "label.yes" },
    NO: { id: 0, label: "label.no" },
}


export {
    MessageType,
    findEnumById,
    YesNoType,
}

export const BatchStatusEnumOption = (OptionEnum) => (
    Object.keys(OptionEnum).map(key => (
        <option key={key} value={key}>{OptionEnum[key]}</option>
    ))
)